"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Input } from "@/components/ui/input";
export default function PonentesDestacados() {
  const {
    ref: headingRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="152199" id="regalos" className="w-full min-h-[120vh] relative bg-dark-background">
      <div className="container mx-auto px-4 md:px-6 py-24">
        <h2 ref={headingRef} className="text-center font-semibold font-display transition-all duration-200 ease-out opacity-100 translate-y-0 !text-6xl !text-[hsl(0,0%,100%)]">
          Regalos
        </h2>
        <div className="text-center mt-6 max-w-2xl mx-auto text-foreground-muted-dark font-sans text-lg">
          <p className="!text-base">Vuestra presencia en nuestro gran día es el mayor regalo que podríamos recibir. Sin embargo, si deseáis realizarnos un detalle, aquí encontraréis el número de cuenta que hemos habilitado.&nbsp; No os olvidéis de poner vuestro nombre en el concepto, !así podremos daros las gracias como se merece!</p>
          <div className="mt-6 max-w-sm mx-auto">
            <Input readOnly defaultValue="ES45 2080 3533 6230 4002 5777" className="mx-auto h-9 w-full rounded-md flex min-w-0 border px-3 py-1 shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-center font-mono bg-white/10 border-white/20 text-white !rounded-lg !h-[54px] !text-xl file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 dark:aria-invalid:ring-destructive/40" />
          </div>
          <div className="card mt-8 max-w-sm mx-auto overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542678/img/image_rjsjiiae.jpg" alt="Regalo" className="w-full object-cover !h-[384px]" />
          </div>
          <p className="mt-8 !text-base italic">Prometemos brindar por vosotros en cada destino</p>
        </div>
      </div>
    </section>;
}